<div id="editAnswerModal" bg-close="false" uk-modal #modal>
  <div class="uk-modal-dialog">
    <button class="uk-modal-close-default" type="button" uk-close></button>

    <div class="uk-modal-header">
      <h3 i18n="@@Question">Create manual PEP Check</h3>

      <p>for {{ name }}</p>
    </div>

    <form [formGroup]="pepCheckForm" (ngSubmit)="createManualPepCheck()">
      <ng-container formArrayName="pepChecks">
        <div class="uk-modal-body" [formGroupName]="i" *ngFor="let pepCheck of pepChecks.controls; let i = index">
          <div *ngIf="companyId">
            <h3 i18n="@@BeneficialOwner">Beneficial Owner</h3>

            <div class="margin-small-right">{{ pepCopy[i].first_name }} {{ pepCopy[i].last_name }}</div>
          </div>

          <h3 i18n="@@Comment">Comment</h3>

          <div class="full-width">
            <textarea class="uk-textarea" placeholder="Comment" i18n-placeholder="@@Comment" rows="5" formControlName="comment"></textarea>
            <div class="form-error error-container">
              <small *ngIf="pepCheck.get('comment').hasError('maxlength')" i18n="@@commentLengthError"
                >Comment can be only 300 letters long.</small
              >
            </div>
          </div>

          <h3 i18n="@@Status">Status</h3>

          <div class="margin-small-right">
            <select formControlName="status" class="uk-select uk-form-small uk-form-width-small">
              <option
                *ngFor="let pepStatus of pepStatusOptions"
                [value]="pepStatus.id"
                [selected]="pepCheck?.get('status')?.value === pepStatus.id">
                {{ pepStatus.label }}
              </option>
            </select>
          </div>
        </div>
      </ng-container>

      <div class="uk-modal-footer">
        <p class="uk-text-right">
          <button class="uk-button uk-button-default uk-modal-close uk-margin-small-right" type="button" i18n="@@cancel">cancel</button>

          <button class="uk-button uk-button-primary confirm-button" type="submit" i18n="@@create">create</button>
        </p>
      </div>
    </form>
  </div>
</div>
